import { notification } from "antd";
import cuid from "cuid";
import { defaults, filter, get, keyBy, last, map, sortBy } from "lodash";
import moment from "moment";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { COLORS } from "shared/style/colors";
import { GENERATE_QUOTE_DOCUMENTS } from "utils/api/graphql/mutations/attachment";
import { CREATE_LINK } from "utils/api/graphql/mutations/link";
import { SEND_B2C_QUOTE } from "utils/api/graphql/mutations/quotes";
import { SUBSCRIPTION } from "utils/api/graphql/queries/subscription";
import {
  CONTACT_POINT_SYSTEM,
  KEYS,
  MILTIS_PHONE_PREFIXES,
} from "utils/constants";
import { filterByConditions } from "../../../..";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const AdherentInfo = ({
  processId,
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_MILTIS.ADHERENT_INFO", { returnObjects: true });
  const subscriptionId =
    localStorage.getItem(KEYS.SUBSCRIPTION_ID) ||
    get(project, "fields.currentSubscription");
  const telecoms = defaults(keyBy(get(project, "contact.telecoms"), "system"), {
    [CONTACT_POINT_SYSTEM.PHONE]: { value: null },
    [CONTACT_POINT_SYSTEM.PHONE_NUMBER_PREFIX]: {
      value: MILTIS_PHONE_PREFIXES[0].value,
    },
    [CONTACT_POINT_SYSTEM.EMAIL]: { value: null },
  });
  const [generateQuoteDocuments] = useMutation(GENERATE_QUOTE_DOCUMENTS);
  const [addLink] = useMutation(CREATE_LINK);
  const [sendQuoteMutation] = useMutation(SEND_B2C_QUOTE);

  const { data } = useQuery(SUBSCRIPTION, {
    variables: { where: { id: subscriptionId } },
  });

  const onSubmit = ({ telecoms, ...contact }) => {
    const status = get(
      last(
        sortBy(
          filter(
            project.statuses,
            ({ status }) => status.process.id === processId,
          ),
          "createdDate",
        ),
      ),
      "status",
    );
    const { possibleStatuses } = status;
    const [possibleStatus] = filterByConditions(
      sortBy(possibleStatuses, "order"),
      {
        ...project,
        status,
      },
    );
    const updatedTelecoms = map(telecoms, (item, key) =>
      defaults(item, { id: cuid(), system: key }),
    );
    const { relatedPersons: _relatedPersons, ...contactWithoutRelatedPersons } =
      contact || {};

    return onNext({
      payload: {
        contact: {
          ...contactWithoutRelatedPersons,
          id: get(project, "contact.id") || cuid(),
          telecoms: updatedTelecoms,
          user: {
            id: cuid(),
            ...contact.user,
          },
        },
        visible: true,
      },
      // onCompleted: () => {
      //   generateQuoteDocuments({
      //     variables: {
      //       data: {
      //         project: { id: project.id },
      //         insurancePlans: [
      //           { id: get(data, "subscription.insurancePlan.id") },
      //         ],
      //       },
      //     },
      //     onCompleted: () => {
      //       const source = localStorage.getItem(KEYS.SOURCE);
      //       addLink({
      //         variables: {
      //           data: {
      //             url: get(
      //               data,
      //               "subscription.insurancePlan.config.generatedUrl",
      //               `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`
      //             ),
      //             project: { id: project.id },
      //             subscription: { id: subscriptionId },
      //             fields: {
      //               process: { id: processId },
      //               status: { id: get(possibleStatus, "nextStatus") },
      //             },
      //           },
      //         },
      //         onCompleted: ({ addLink }) => {
      //           sendQuoteMutation({
      //             variables: {
      //               data: {
      //                 link: addLink?.id,
      //                 project: { id: project.id },
      //                 insurancePlans: [
      //                   { id: get(data, "subscription.insurancePlan.id") },
      //                 ],
      //               },
      //             },
      //             onCompleted: () =>
      //               notification.open({
      //                 message: "Devis envoyé",
      //                 duration: 5,
      //                 icon: (
      //                   <IoCheckmarkCircleOutline color={COLORS.C_SUCCESS} />
      //                 ),
      //               }),
      //           });
      //         },
      //       });
      //     },
      //   });
      // },
    });
  };
  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        tracer={tracer}
        step={4}
        stepCount={5}
        title={TRANSLATION?.NAVBAR?.TITLE || "Mes informations contractuelles"}
      />
      <View
        contact={{ ...get(project, "contact", {}), telecoms }}
        onNext={onSubmit}
        onBack={onBack}
        locked={false}
        translate={TRANSLATION}
      />
    </>
  );
};

export default AdherentInfo;
